(()=>{
 document.querySelectorAll(':is(#shopify-section-knp-versa-kg,#shopify-section-knp-versa-mini-kg) #KsWeightsBuy').forEach(root=>{
  const mini=root.parentElement.id==='shopify-section-knp-versa-mini-kg';
  const files=mini?{'2.5':'versa-2.5kg.jpg','5':'versa-5kg-versa.jpg'}:{'10':'versa-10kg.png','20':'versa-20kg.png'};
  const photos=Array.from(root.querySelectorAll('.ks-pdp-slide img'));
  root.querySelectorAll('.ks-pdp-option').forEach(button=>{
   const weight=button.querySelector('strong')?.textContent.trim().match(/^[\d.]+/)?.[0];
   const file=files[weight];
   if(!file||button.querySelector('.vk-weight-photo'))return;
   const photo=photos.find(image=>image.src.includes('/'+file+'?'));
   if(!photo)return;
   const image=document.createElement('img');
   image.src=photo.src.replace(/([?&])width=\d+/,'$1width=240');
   image.alt='';image.width=70;image.height=74;image.className='vk-weight-photo';
   button.prepend(image);
  });
  root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
   const item=document.createElement('div');item.className=link.className;
   while(link.firstChild)item.append(link.firstChild);
   link.replaceWith(item);
  });
 });
})();
